module.exports = __webpack_public_path__ + "img/Y5.f8c10dd1.png";